import type { Directive, DirectiveBinding } from 'vue'
import { trackEvent } from '@/utils/gtm/trackEvent.ts'

type TrackEventValue = string | { name: string, [key: string]: unknown }

/**
 * Track Google Analytics event, push directly to datalayer
 * @param binding The event name or an object of name + properties
 */
export const vTrackEvent: Directive<HTMLElement, TrackEventValue> = {
  mounted(el, binding: DirectiveBinding<TrackEventValue>) {
    const handler = () => {
      if (typeof binding.value === 'string') {
        if (!import.meta.env.PROD) {
          console.debug(`[Tracking] "${binding.value}" Event tracked for: `, el)
        }
        trackEvent(binding.value)
      } else if (binding.value?.name) {
        const {name, ...props} = binding.value
        if (!import.meta.env.PROD) {
          console.debug(`[Tracking] "${name}" Event tracked for: `, el, props)
        }
        trackEvent(name, props)
      } else {
        if (!import.meta.env.PROD) {
          console.warn('[Tracking] found unnamed or malformed event trigger on:', el)
        }
      }
    }

    el.addEventListener('click', handler)
  }
}
